import { NgModule, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER, PLATFORM_ID, makeStateKey, TransferState, ErrorHandler } from '@angular/core';
import { GlobalErrorHandler } from './global-error-handler';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { HeaderTopBoxComponent } from './header-top-box/header-top-box.component';
import { CurrentRouteService } from './services/current-route.service';
import { ScheduleDemoComponent } from './components/schedule-demo/schedule-demo.component';
import { HttpClient, provideHttpClient, withInterceptorsFromDi, withFetch } from '@angular/common/http';
import { DatePipe, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { LoadingComponent } from './loading/loading.component';
import { MatSliderModule } from '@angular/material/slider';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader, TRANSLATE_HTTP_LOADER_CONFIG } from '@ngx-translate/http-loader';
import { lastValueFrom } from 'rxjs';

import { ReactiveFormsModule } from '@angular/forms';

const TRANSLATIONS_KEY = makeStateKey<any>('translations');


export function loadTranslations(
  translate: TranslateService,
  platformId: object
) {
  return () => {
    const lang = "en";
    if (isPlatformBrowser(platformId)) {
      return lastValueFrom(translate.use(lang));
    } else if (isPlatformServer(platformId)) {
      return lastValueFrom(translate.use(lang));
    } else {
      return Promise.resolve();
    }
  };
}


@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HeaderComponent,
    HeaderTopBoxComponent,
    LoadingComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent], imports: [BrowserModule,
    AppRoutingModule,
    CarouselModule,
    BrowserAnimationsModule,
    MatSliderModule,
    RouterModule,
    ReactiveFormsModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useClass: TranslateHttpLoader,
      }
    })], providers: [CurrentRouteService, DatePipe,
      {
        provide: TRANSLATE_HTTP_LOADER_CONFIG,
        useValue: { prefix: './assets/i18n/', suffix: '.json' }
      },
      {
        provide: APP_INITIALIZER,
        useFactory: loadTranslations,
        deps: [TranslateService, PLATFORM_ID],
        multi: true
      }, { provide: ErrorHandler, useClass: GlobalErrorHandler }, provideHttpClient(withInterceptorsFromDi())]
})
export class AppModule {
  constructor(translate: TranslateService) {
    translate.setDefaultLang('en');
    translate.use('en');
  }
}
